import { render, staticRenderFns } from "./cgDetails.vue?vue&type=template&id=7a18877b&scoped=true"
import script from "./cgDetails.vue?vue&type=script&lang=js"
export * from "./cgDetails.vue?vue&type=script&lang=js"
import style0 from "./cgDetails.vue?vue&type=style&index=0&id=7a18877b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a18877b",
  null
  
)

export default component.exports